export default __webpack_public_path__ + "static/media/Truck left.6b64400c.svg";